// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var JsxRuntime = require("react/jsx-runtime");
var User$ReactHooksTemplate = require("./user.res.js");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var DomainModel$ReactHooksTemplate = require("./domainModel.res.js");

function isDeleteKeyword(inputKeyword) {
  return inputKeyword.toUpperCase() === "DELETE";
}

function ConfirmationDialog(props) {
  var match = React.useState(function (param) {
        return "";
      });
  var setKeyword = match[1];
  var keyword = match[0];
  var handleDeleteConfirmation = function ($$event) {
    Curry._1(setKeyword, $$event.target.value);
  };
  var disabled = keyword.toUpperCase() !== "DELETE";
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("button", {
                            children: JsxRuntime.jsx("img", {
                                  className: "h-4 w-4 cursor-pointer",
                                  src: Image$ReactHooksTemplate.closeIcon
                                }),
                            className: "absolute top-4 right-4 text-gray-400 hover:text-gray-600 focus:outline-none",
                            onClick: props.handleClose
                          }),
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("div", {
                                    children: JsxRuntime.jsx("span", {
                                          children: "⚠️",
                                          className: "text-lg"
                                        }),
                                    className: "w-10 h-10 rounded-lg bg-gradient-to-br from-red-100 to-red-200 flex items-center justify-center"
                                  }),
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx("h2", {
                                            children: "Delete User",
                                            className: "text-xl font-semibold text-gray-900"
                                          }),
                                      JsxRuntime.jsx("p", {
                                            children: "This action cannot be undone.",
                                            className: "text-sm text-gray-600"
                                          })
                                    ]
                                  })
                            ],
                            className: "flex items-center mb-6 space-x-3"
                          }),
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("p", {
                                    children: "You are about to permanently delete this user:",
                                    className: "text-sm text-gray-700 mb-1"
                                  }),
                              JsxRuntime.jsx("p", {
                                    children: Curry._1(DomainModel$ReactHooksTemplate.$$String.Email.show, User$ReactHooksTemplate.email(props.user)),
                                    className: "font-medium text-gray-900 break-all"
                                  })
                            ],
                            className: "bg-gray-50 border border-gray-200 rounded-lg p-4 mb-6"
                          }),
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("img", {
                                    className: "w-5 h-5 mr-3 mt-0.5",
                                    src: Image$ReactHooksTemplate.errorInfoIcon
                                  }),
                              JsxRuntime.jsx("p", {
                                    children: "This action will permanently delete this user and their associated data. Type DELETE to confirm.",
                                    className: "text-sm text-red-700 leading-snug"
                                  })
                            ],
                            className: "flex items-start bg-red-50 border border-red-200 rounded-lg p-4 mb-6"
                          }),
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("label", {
                                    children: "Type DELETE to confirm",
                                    className: "block text-sm font-medium text-gray-700 mb-2"
                                  }),
                              JsxRuntime.jsx("input", {
                                    className: "w-full border border-gray-300 rounded-lg px-3 py-2 bg-white text-gray-900 uppercase placeholder-gray-400 focus:border-red-500 focus:ring-2 focus:ring-red-500 outline-none transition-all",
                                    placeholder: "DELETE",
                                    type: "text",
                                    value: keyword,
                                    onChange: handleDeleteConfirmation
                                  })
                            ],
                            className: "mb-6"
                          }),
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("button", {
                                    children: "Cancel",
                                    className: "px-4 py-2 text-sm text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 transition",
                                    type: "button",
                                    onClick: props.handleCancel
                                  }),
                              JsxRuntime.jsx("button", {
                                    children: "Delete",
                                    className: "px-6 py-2 text-sm font-medium rounded-lg border transition-all duration-200 " + (
                                      disabled ? "bg-red-100 border-red-200 text-red-400 cursor-not-allowed" : "bg-red-600 text-white border-red-600 hover:bg-red-700"
                                    ),
                                    disabled: disabled,
                                    onClick: props.handleDelete
                                  })
                            ],
                            className: "flex justify-end space-x-3 border-t border-gray-200 pt-4"
                          })
                    ],
                    className: "relative bg-white w-full max-w-md rounded-xl shadow-2xl border border-gray-200 p-8 overflow-hidden"
                  }),
              className: "fixed inset-0 z-50 flex items-center justify-center"
            });
}

var make = ConfirmationDialog;

exports.isDeleteKeyword = isDeleteKeyword;
exports.make = make;
/* react Not a pure module */
